var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: [
        "product-detail",
        "product-detail-vue",
        _vm.bemBlockMod({
          disabled: !_vm.selectedMainProduct || _vm.disabled
        })
      ],
      attrs: { "data-context": _vm.context },
      on: { click: _vm.handleProductClick }
    },
    [
      _c("BaseProductDataForSfra", { attrs: { product: _vm.product } }),
      _vm._v(" "),
      _c("img", {
        class: _vm.bemElement("image"),
        attrs: { src: _vm.imageUrl, alt: _vm.product.productName }
      }),
      _vm._v(" "),
      _vm.selectedCurrentProduct && _vm.selectedCurrentProduct.qty > 0
        ? _c("div", { class: _vm.bemElement("image-underline") })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedCurrentProduct && _vm.selectedCurrentProduct.qty > 1
        ? _c("div", { class: _vm.bemElement("amount-indicator") }, [
            _c("span", { class: _vm.bemElement("amount-number") }, [
              _vm._v(
                "\n      " + _vm._s(_vm.selectedCurrentProduct.qty) + "\n    "
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }